import { useMutation } from "@tanstack/react-query";

import { savePostModuleAssessment } from "./utils.api";

export const useSavePostChapterAssessment = () =>
    useMutation({
        mutationFn: (body) =>
            savePostModuleAssessment(body),
    });